import { render } from "./AddressComponent.vue?vue&type=template&id=3f5fc708"
import script from "./AddressComponent.vue?vue&type=script&lang=js"
export * from "./AddressComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/account/address/AddressComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f5fc708"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f5fc708', __exports__)) {
    api.reload('3f5fc708', __exports__)
  }
  
  module.hot.accept("./AddressComponent.vue?vue&type=template&id=3f5fc708", () => {
    api.rerender('3f5fc708', render)
  })

}


export default __exports__